import { object } from "../helpers/object";
import { debug } from "../helpers/debug";



class DatesFormations {
  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;

    // CHANGE EVENT
    document.addEventListener('change', this.changeHandler);

    if(debug.DEBUG) console.log('async/dates-formations.js');
  }
  changeHandler = (event) => {
    if (event.target.matches('[data-js-trigger="dates-formations"]')) {
      const value = event.target.value;
      if (!value) return;
      this.selectFormation(value);
    }
  };
  selectFormation = (value) => {
    document.querySelectorAll('[data-js-date-formation]').forEach(formation => {
      if (formation.getAttribute('data-js-date-formation') === value) {
        formation.setAttribute('aria-hidden', false);
        formation.classList.remove('u-hidden');
      } else {
        formation.setAttribute('aria-hidden', true);
        formation.classList.add('u-hidden');
      }
    });
  }

}
export default new DatesFormations('[data-js-component="dates-formations"]'); 